export const Select = `
    const [selectOptions] = React.useState([
        {
        label: 'Option 1',
        value: 'option-1',
        },
        {
        label: 'Option 2',
        value: 'option-2',
        },
    ])

    const handleSelect = (e: any) => {
        alert('Option was selected')
    }

    <div>
        <Select
            label="Select with error"
            required={true}
            isInvalid={true}
            isInvalidText="Please enter a valid name"
            className="custom-class"
            onChange={e => handleSelect(e)}
            options={selectOptions}
        />
        <Select
            label="Select with error"
            required={true}
            isInvalid={true}
            isInvalidText="Please enter a valid name"
            className="custom-class"
            onChange={e => handleSelect(e)}
            size="lg"
        />
    </div>
`
